import React, { useContext, useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";

import ApplicationContext from "../../../context/ApplicationContext";
import { useNavigate } from "react-router-dom";
import {
  deleteSnookerTables,
  getSnookerTables,
} from "../../../services/Service";
import { generateGUID } from "../../../helpers/Helpers";
import { ISnookerTable } from "../../../types/ISnookerTable";

export interface IAllProductsProps {
  editId(id: number): void;
}

export const MobileMenu: React.FC = (): JSX.Element => {
  const context = useContext(ApplicationContext);
  const navigate = useNavigate();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState("");

  async function getSnookerSettings() {
    setLoading(true);
    const response = await getSnookerTables(
      context.AuthenticatedUser.getToken()
    );

    if (!response) {
      context.ApplicationError.setHasError(true);
      return;
    }

    context.Snooker.setData(response);

    setRefresh(generateGUID());
    setLoading(false);
  }

  useEffect(() => {
    getSnookerSettings();
    setRefresh(generateGUID());
  }, []);

  function deleteTable(st: ISnookerTable) {
    context.Snooker.setSelected(st);
    setShowDeleteModal(true);
  }

  async function confirmDeleteTable() {
    setLoading(true);

    const response = await deleteSnookerTables(
      context.AuthenticatedUser.getToken(),
      context.Snooker.getSelected().uuid
    );

    if (!response) {
      context.ApplicationError.setHasError(true);
      return;
    }

    getSnookerSettings();

    setLoading(false);
  }

  function editTable(st: ISnookerTable) {
    navigate("/TableEditor/" + st.id);
  }

  const deleteModal = (): JSX.Element => {
    return (
      <>
        Hi
        <Modal show={showDeleteModal}>
          <Modal.Header closeButton onClick={() => setShowDeleteModal(false)}>
            <Modal.Title>Modal heading</Modal.Title>
          </Modal.Header>
          <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary">Close</Button>
            <Button variant="primary">Save Changes</Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  function formatDateForDisplay(d: Date) {
    const dt = new Date(d);
    return dt.getHours() + ":" + dt.getMinutes();
  }

  const tableRow = (st: ISnookerTable) => (
    <>
      <tr>
        <td>{st.position}</td>
        <td>{st.description}</td>
        <td>{st.peekPrice.toFixed(2)}</td>
        <td>{st.offPeekPrice.toFixed(2)}</td>
        <td>{formatDateForDisplay(st.peekStart)}</td>
        <td>{formatDateForDisplay(st.peekEnd)}</td>
        <td>{st.style}</td>
        <td>
          <Button onClick={() => setShowDeleteModal(true)}>Mini</Button>
          {/* <Button variant="outline-primary" onClick={() => editTable(st)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-file-diff"
              viewBox="0 0 16 16"
            >
              <path d="M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4m-2.5 6.5A.5.5 0 0 1 6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5" />
              <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1" />
            </svg>
          </Button> */}
        </td>
        <td>
          <Button variant="outline-primary" onClick={() => deleteTable(st)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-file-earmark-x"
              viewBox="0 0 16 16"
            >
              <path d="M6.854 7.146a.5.5 0 1 0-.708.708L7.293 9l-1.147 1.146a.5.5 0 0 0 .708.708L8 9.707l1.146 1.147a.5.5 0 0 0 .708-.708L8.707 9l1.147-1.146a.5.5 0 0 0-.708-.708L8 8.293z" />
              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
            </svg>
          </Button>
        </td>
      </tr>
    </>
  );

  const tablesView = (): JSX.Element => (
    <>
      <h3>Snooker tables</h3>
      <Button variant="primary">New</Button>
      I am mobile view
      <br />
      <br />
      <div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Username</th>
            </tr>
          </thead>
          <tbody>
            {context.Snooker.getData().map((data) => tableRow(data))}
          </tbody>
        </Table>
      </div>
    </>
  );

  return (
    <>
      <>{deleteModal()}</>
      <>{tablesView()}</>
    </>
  );
};
